import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CampaignDto } from "../../../models/campaign/dto/campaign.dto";

export const GET_CAMPAIGNS_QUERY_KEY = (organizationId: string) => ['campaigns', 'list', organizationId];

export const useListCampaigns = (organizationId: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CAMPAIGNS_QUERY_KEY(organizationId),
        queryFn: () => client.fetchApi<CampaignDto[], {}>({
            endpoint: `campaigns/admin/${organizationId}`,
            method: 'GET'
        }),
        staleTime: 30_000,
        enabled: !!organizationId,
    });
};
